<section class="breadcrumb-area mt-0 py-4">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="breadcrumb-box text-center">
          <h1 style="font-size: 15px; color: #8d8e92;text-transform: none;">
            {{h1}}
          </h1>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="shopping-cart">
  <div class="container">

     <app-notify-alert [Type]="(success$ | async) == true ? 0 : 2" [Message]="message$" [Close]="closeAction">
    </app-notify-alert>

    <app-notify-alert
      [Notification]="(notification$)"
      [Type]="(notification$ | async)?.messageType" >
   </app-notify-alert>

    <ng-container *ngIf="((shoppingCart$ | async).totalItems==0); else templateResult">
        <div class="row">
          <div class="col-md-12">
            <div class="text-center">
              <i style="font-size: 40px;color: #0c8efe;" class="fa fa-shopping-cart"></i>
              <h5 style="padding: 5px;">
                No encontramos resultados.
              </h5>
              <a routerLink="/market/productos-compras-cuba-online"
                style="color: #007bff !important;text-decoration: underline !important;">
                Ver productos
              </a>
            </div>
          </div>
        </div>
    </ng-container>

    <ng-template #templateResult>
      <div class="row">
        <div class="col-md-12">
          <div class="cart-table table-responsive">
            <table class="table">
              <thead>
                <tr class="d-none d-md-table-row">
                  <th class="t-pro">Producto</th>
                  <th class="t-price">Precio</th>
                  <th class="t-qty">Cantidad</th>
                  <th class="t-total">Total</th>
                  <th class="t-shipping">Envio</th>
                  <th class="t-rem">
                    <!-- <a href="javascript:void(0)" (click)="clearCart()">
                      <i class="fa fa-trash-o"></i>
                    </a> -->
                  </th>
                </tr>

                <tr>
                  <th style="padding: 0 !important;" colspan="6">
                    <div *ngIf="(isLoading$ | async)" class="progress-bar progress-bar-striped progress-bar-animated" style="width:100%; height: 5px;"></div>
                  </th>
                </tr>

              </thead>

              <tbody *ngFor="let product of (shoppingCart$ | async).items; let index = index;">
                <tr>

                <td class="t-pro t-qty d-flex flex-column">
                    <div class="d-block d-md-flex">

                      <div class="t-img" style="width: 30%;padding:10px">

                        <ng-container *ngIf="product.productProvider==1">
                          <div class="provider-item">
                            <img src="assets/amazon-logo.svg" alt="Amazon">
                           </div>
                          <a routerLink='/market/productos-compras-cuba-online/amazon/{{product.code}}'>
                            <img class="main-img img-fluid"
                                 src="{{product.previewUrl?.length>0?product.previewUrl:'assets/xemart/images/notImg.png'}}" />
                          </a>
                        </ng-container>

                        <ng-container *ngIf="product.productProvider==2">
                          <div class="provider-item">
                            <img src="assets/shein-logo.svg" alt="Shein">
                           </div>
                          <a routerLink='/market/productos-compras-cuba-online/shein/{{product.code}}'>
                            <img  class="main-img img-fluid"
                                 src="{{product.previewUrl?.length>0?product.previewUrl:'assets/xemart/images/notImg.png'}}" />
                          </a>
                        </ng-container>

                        <ng-container *ngIf="product.productProvider==3">
                          <div class="provider-item">
                            <img src="assets/walmart-icon.svg" alt="walmart">
                           </div>
                          <a routerLink='/market/productos-compras-cuba-online/walmart/{{product.code}}'>
                            <img  class="main-img img-fluid"
                                 src="{{product.previewUrl?.length>0?product.previewUrl:'assets/xemart/images/notImg.png'}}" />
                          </a>
                        </ng-container>

                        <ng-container *ngIf="product.productProvider==4">
                          <div class="provider-item">
                            <img src="assets/homedepot-logo.svg" alt="homedepot">
                           </div>
                          <a routerLink='/market/productos-compras-cuba-online/homedepot/{{product.code}}'>
                            <img  class="main-img img-fluid"
                                 src="{{product.previewUrl?.length>0?product.previewUrl:'assets/xemart/images/notImg.png'}}" />
                          </a>
                        </ng-container>

                        <ng-container *ngIf="product.productProvider==5">
                          <div class="provider-item">
                            <img src="assets/bestbuy-icon.svg" alt="bestbuy">
                           </div>
                          <a routerLink='/market/productos-compras-cuba-online/bestbuy/{{product.code}}'>
                            <img  class="main-img img-fluid"
                                 src="{{product.previewUrl?.length>0?product.previewUrl:'assets/xemart/images/notImg.png'}}" />
                          </a>
                        </ng-container>

                        <ng-container *ngIf="!product.productProvider || product.productProvider==0">

                           <div class="provider-item">
                            <img src="assets/cubatel.png" alt="Cubatel">
                           </div>

                          <a routerLink='/market/productos-compras-cuba-online/cubatel/{{product.code}}'>
                            <img  class="main-img img-fluid"
                                 src="{{product.previewUrl?.length>0?product.previewUrl:'assets/xemart/images/notImg.png'}}" />
                          </a>
                        </ng-container>

                      </div>


                       <div class="t-content" style="width: 70%;padding:10px">

                        <p class="t-heading">

                          <ng-container *ngIf="product.provider==0 || product.productProvider==0">
                            <a routerLink='/market/productos-compras-cuba-online/cubatel/{{product.code}}'>
                              {{product.name}}
                            </a>
                          </ng-container>
                          <ng-container *ngIf="product.provider==1 || product.productProvider==1">
                            <a routerLink='/market/productos-compras-cuba-online/amazon/{{product.code}}'>
                              {{product.name}}
                            </a>
                          </ng-container>

                          <ng-container *ngIf="product.provider==2 || product.productProvider==2">
                            <a routerLink='/market/productos-compras-cuba-online/shein/{{product.code}}'>
                              {{product.name}}
                            </a>
                            <p *ngIf="product.attributesToShow.length>0" class="t-heading pr-md-4">
                              {{product.attributesToShow}}
                            </p>
                          </ng-container>

                          <ng-container *ngIf="product.provider==3 || product.productProvider==3">
                            <a routerLink='/market/productos-compras-cuba-online/walmart/{{product.code}}'>
                              {{product.name}}
                            </a>
                            <p *ngIf="product.attributesToShow.length>0" class="t-heading pr-md-4">
                              {{product.attributesToShow}}
                            </p>
                          </ng-container>

                          <ng-container *ngIf="product.provider==4 || product.productProvider==4">
                            <a routerLink='/market/productos-compras-cuba-online/homedepot/{{product.code}}'>
                              {{product.name}}
                            </a>
                            <p *ngIf="product.attributesToShow.length>0" class="t-heading pr-md-4">
                              {{product.attributesToShow}}
                            </p>
                          </ng-container>

                          <ng-container *ngIf="product.provider==5 || product.productProvider==5">
                            <a routerLink='/market/productos-compras-cuba-online/bestbuy/{{product.code}}'>
                              {{product.name}}
                            </a>
                            <p *ngIf="product.attributesToShow.length>0" class="t-heading pr-md-4">
                              {{product.attributesToShow}}
                            </p>
                          </ng-container>

                        </p>

                        <p style="color: #5677fc!important;" class="t-heading">
                          <a routerLink="/market/tiendas-asociadas/{{product.supplierCode}}">
                            {{product.supplierLinkToShow}}
                          </a>
                        </p>

                        <ng-container *ngIf="product.productProvider!=2">
                          <p *ngIf="product.summaryText && product.showDescriptionSummary" style="max-width: 550px;" align="justify" class="t-heading pr-md-4">
                            {{product.summaryText}}<span class="show-more cursor-pointer" (click)="product.showDescriptionSummary = false"> Ver más</span>
                          </p>
                          <p *ngIf="!product.summaryText || (product.summaryText && !product.showDescriptionSummary)" style="max-width: 550px;padding-right: 20px;" align="justify" class="t-heading">
                            {{product.shortText}}<span class="show-more cursor-pointer" *ngIf="product.summaryText" (click)="product.showDescriptionSummary = true"> Ver menos</span>
                          </p>

                       </ng-container>

                      </div>

                    </div>
                  </td>



                  <td style="width: 13%" class="t-price d-md-table-cell">

                    {{product.priceToShow}}
                    <span *ngIf="product.oldPriceToShow.length>0" style="font-size: 14px; text-decoration: line-through;color: #8d8e8f;">
                      {{product.oldPriceToShow}}
                    </span>

                  </td>


                  <td style="width: 15%" class="t-qty d-none d-md-table-cell">
                    <div class="qty-box">
                      <div class="quantity buttons_added">
                        <input type="button" value="-" class="minus" (click)="pullFromCart(product)">
                        <input type="number" step="1" min="1" max="10" value="{{product.quantity}}" class="qty text"
                          size="4" readonly>
                        <input type="button" value="+" class="plus" (click)="pushToCart(product)">
                      </div>
                    </div>
                  </td>
                  <td style="width: 10%" class="t-total d-none d-md-table-cell"> {{product.amountToShow}}</td>
                  <td style="width: 5%" class="t-qty d-none d-md-table-cell">
                    <app-shopping-shipping [product]="product" >
                    </app-shopping-shipping>
                  </td>
                  <td style="width: 5%" class="t-rem d-none d-md-table-cell">
                    <a href="javascript:void(0)" (click)="deleteFromCart(product)">
                      <i class="fa fa-trash-o"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-md-8">
        </div>
        <div class="col-md-4">
          <div class="crt-sumry">
            <ul class="list-unstyled"
              style="border-bottom: 1px solid #dddddd;padding-bottom: 10px;margin-bottom: 10px;">
              <li>Subtotal
                <span>{{(shoppingCart$ | async).totalPriceToShow}}</span>
              </li>
            </ul>
            <div class="cart-btns text-right">
              <button routerLink="../../../revisar-completar-pedido" type="button" class="chq-out">
                Ir a pagar
              </button>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</section>

